import React, { useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user, loading, setUser, refresh } = useAuth();
  const location = useLocation();

  // Defense-in-depth: if AuthCallback navigated here with `state.user` but
  // AuthContext.user wasn't hydrated yet (rare batched-render race), pick it up.
  useEffect(() => {
    if (!user && location.state?.user) {
      setUser(location.state.user);
    }
  }, [user, location.state, setUser]);

  // If we land on a protected route with no user *and* no state.user, do a
  // server check before bouncing to /login. This catches the edge case where
  // the user has a valid cookie but AuthContext skipped its initial /me check
  // (e.g. came back from OAuth via a route other than AuthCallback).
  useEffect(() => {
    if (!loading && !user && !location.state?.user) {
      refresh();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white">
        <div className="w-8 h-8 border-2 border-slate-200 border-t-blue-700 rounded-full animate-spin" />
      </div>
    );
  }
  const effectiveUser = user || location.state?.user;
  if (!effectiveUser) return <Navigate to="/login" replace state={{ from: location }} />;
  return children;
}
